import {Model} from '@chaysehartsuff/active-html';


export default class Blog extends Model {

    id;
    title;
    description;
    user_id;
    meta_data;
    created_at;
    updated_at;
}